/**
 * ProductCartAddAPI
 * Shopify API を利用してカートに商品を追加する
 * https://shopify.dev/docs/api/ajax/reference/cart#post-locale-cart-add-js
 * @param {FormData} formData - フォームデータ
 */

async function ProductCartAddAPI(formData) {
	const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
		method: "POST",
		body: formData,
	});
	return response;
}

/**
 * GetCartDataAPI
 */
async function GetCartDataAPI() {
	const response = await fetch(window.Shopify.routes.root + 'cart.js');
	return response;
}
